/**
 * Lightweight store for tournament cup display
 * PERFORMANCE OPTIMIZED: Only tracks which games should show cups
 * Doesn't modify game data - just provides cup visibility info
 */

import { create } from 'zustand';

interface TournamentCupState {
  // Set of game keys that should show tournament cups
  gamesWithCups: Set<string>;

  // Actions
  setGamesWithCups: (gameKeys: string[]) => void;
  clearAllCups: () => void;
  hasGameCup: (gameKey: string) => boolean;
}

export const useTournamentCupStore = create<TournamentCupState>((set, get) => ({
  gamesWithCups: new Set<string>(),

  setGamesWithCups: (gameKeys: string[]) => {
    set({ gamesWithCups: new Set(gameKeys) });
  },

  clearAllCups: () => {
    set({ gamesWithCups: new Set<string>() });
  },

  hasGameCup: (gameKey: string) => {
    return get().gamesWithCups.has(gameKey);
  },
}));

// Optimized selector for individual game cup status
export const useGameCupStatus = (gameKey: string): boolean => {
  return useTournamentCupStore((state) => state.gamesWithCups.has(gameKey));
};
